// import axios from 'axios';
import { useRequest, setupGlobals } from 'use-react-api-request';

setupGlobals({
  // or any other API-client that you use
  // isCancel: axios.isCancel,
});

export { useRequest };
